import React from 'react'
import image2 from '../assets/picture2.jpg'

const User = () => {
  return (
    <div className='user'>
        <div className='created_date'>
            <p><strong>post created: </strong>Just Now</p>
            <h5>Author: Muzi Abas</h5>
        </div>
    </div>
  )
}

export default User